import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaterialSelect from '@material-ui/core/Select';
import MaterialFormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import classnames from 'classnames';
import styles from './styles.module.scss';

/**
 * Another select component, with selectable placeholder.  This component assumes that `defaultValue` is the the placeholder's value.
 */
export const Select = forwardRef(
    (
        {
            helperText,
            value,
            children,
            placeholder,
            defaultValue,
            options,
            className,
            ...props
        },
        ref
    ) => {
        const placeholderIsSelected = defaultValue && value === defaultValue;

        const selectClassNames = classnames(styles.root, className, {
            [styles.placeholder]: placeholderIsSelected
        });

        return (
            <MaterialFormControl fullWidth>
                <MaterialSelect
                    variant="outlined"
                    fullWidth
                    value={value}
                    defaultValue={defaultValue}
                    ref={ref}
                    className={selectClassNames}
                    {...props}
                >
                    {placeholder && (
                        <MenuItem
                            value={defaultValue}
                            className="NeptuneDropdown-placeholder"
                        >
                            {placeholder}
                        </MenuItem>
                    )}
                    {options.map(({ text, value: v }) => (
                        <MenuItem key={v} value={v}>
                            {text}
                        </MenuItem>
                    ))}
                    {children}
                </MaterialSelect>
                {helperText && (
                    <FormHelperText variant="outlined" error={props.error}>
                        {helperText}
                    </FormHelperText>
                )}
            </MaterialFormControl>
        );
    }
);

Select.displayName = 'NeptuneDropdown';

Select.propTypes = {
    ...MaterialSelect.propTypes,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.any.isRequired,
            value: PropTypes.any.isRequired
        })
    ),
    placeholder: PropTypes.any
};

Select.defaultProps = {
    ...MaterialSelect.defaultProps,
    options: [],
    placeholder: null
};
